import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Typography,
} from '@mui/material';

interface MultiCheckboxGroupProps {
  name: string;
  label?: string;
  options: Array<{
    value: string | number;
    label: string;
  }>;
  required?: boolean;
  disabled?: boolean;
  row?: boolean;
}

export const MultiCheckboxGroup: React.FC<MultiCheckboxGroupProps> = ({
  name,
  label,
  options,
  required,
  disabled,
  row = false,
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={[]}
      render={({ field, fieldState: { error } }) => (
        <FormControl component="fieldset" fullWidth error={!!error}>
          {label && (
            <Typography variant="subtitle1" gutterBottom component="div">
              {label}
              {required && <span style={{ color: 'red' }}> *</span>}
            </Typography>
          )}
          <FormGroup row={row}>
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                control={
                  <Checkbox
                    checked={field.value.includes(option.value)}
                    onChange={(e) => {
                      const newValue = [...field.value];
                      if (e.target.checked) {
                        newValue.push(option.value);
                      } else {
                        const index = newValue.indexOf(option.value);
                        if (index !== -1) {
                          newValue.splice(index, 1);
                        }
                      }
                      field.onChange(newValue);
                    }}
                    disabled={disabled}
                    sx={{
                      padding: '8px',
                      '& .MuiSvgIcon-root': { fontSize: 24 },
                    }}
                  />
                }
                label={<Typography variant="body1">{option.label}</Typography>}
                sx={{
                  marginLeft: 0,
                  marginRight: 2,
                  alignItems: 'center',
                }}
              />
            ))}
          </FormGroup>
          {error && (
            <Typography variant="caption" color="error">
              {error.message}
            </Typography>
          )}
        </FormControl>
      )}
    />
  );
};
